import { forwardRef } from "react";
import { SvgIcon, type SvgIconProps } from "@mui/material";

const Facebook = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon viewBox="0 0 24 24" ref={ref} {...props}>
      <path d="M13.8282 23.8412V13.0424H17.4587L18.0172 8.81449H13.8282V6.12216C13.8282 4.90191 14.1689 4.06971 15.9199 4.06971H18.1373V0.299659C17.0577 0.183483 15.9724 0.127371 14.8867 0.132113C11.6696 0.132113 9.46625 2.08682 9.46625 5.70329V8.81422H5.83582V13.0421H9.46625V23.8412H13.8282Z" />
    </SvgIcon>
  );
});

Facebook.displayName = "Facebook";

export default Facebook;
